<template>
    <div class="view view-challenge-select-mode">
        <HeaderChallengeSelectMode
            textH1="Pratik Modu Seçimi"
            textH2="Karşılaşmanın pratik modunu seç." />
        <ChallengeUserItemSelected
            :userItem="this.$store.state.selectedUser" />

        <Preloader
            v-if="showPreloader"
            preloaderText="Ortam hazırlanıyor..." />

        <Swiper
            v-if="!showPreloader"
            :modules="swiperModules"
            :pagination="{ clickable: true }"
            :slides-per-view="1"
            @swiper="onSlideChange"
            @slideChange="onSlideChange">
            <SwiperSlide v-for="mode in this.$store.state.practiceModes" :key="mode.id">
                <ChallengePracticeMode
                    :mode="mode" />
            </SwiperSlide>
        </Swiper>

        <BtnChallenge />
        <BtnPracticeStart
            @click="initPractice" />
        <Navbar />
    </div>
</template>

<script>

    // Library imports
    import { Swiper, SwiperSlide} from 'swiper/vue';
    import 'swiper/css';
    import { Pagination }       from 'swiper';
    import FakeApi              from '@/libs/FakeApi.js';

    // Component imports
    import HeaderChallengeSelectMode    from '@/components/HeaderChallengeSelectMode.vue';
    import ChallengeUserItemSelected    from '@/components/ChallengeUserItemSelected.vue';
    import Preloader                    from '@/components/Preloader.vue';
    import ChallengePracticeMode        from '@/components/ChallengePracticeMode.vue';
    import BtnChallenge                 from '@/components/BtnChallenge.vue';
    import BtnPracticeStart             from '@/components/BtnPracticeStart.vue';
    import Navbar                       from '@/components/Navbar.vue';

    export default {
        components: {
            Swiper,
            SwiperSlide,
            HeaderChallengeSelectMode,
            ChallengeUserItemSelected,
            Preloader,
            ChallengePracticeMode,
            BtnChallenge,
            BtnPracticeStart,
            Navbar,
        },

        data(){
            return {
                swiperModules: [Pagination],
                selectedMode: null,
                showPreloader: false,
                canInit: true,
            };
        },

        methods: {
            onSlideChange(swiper){
                this.selectedMode = this.$store.state.practiceModes[swiper.activeIndex];
                console.log(`idx: ${swiper.activeIndex}`, `selectedMode: `, this.selectedMode);
            },

            initPractice(){
                // Check if user can init practice to avoid multiple click requests.
                if(this.canInit !== true){
                    console.warn("VIEW_CHALLENGE_SELECT_MODE/INIT_PRACTICE::MULTIPLE_REQUESTS_NOT_ALLOWED");
                    return;
                }
                this.canInit = false;

                // Enable preloader.
                this.showPreloader = true;

                // Arrange $challengeOptions request body.
                let challengeOptions = {
                    idUser2: this.$store.state.selectedUser.id,
                    type: this.selectedMode.type
                };

                // Send request to API.
                fetch(this.$store.state.api.challengeInitialize, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: "challengeOptions=" + JSON.stringify(challengeOptions),
                })
                    .then(async response => {
                        if(response.status !== 200){
                            throw await response.json();
                        }
                        return response.json();
                    })
                    .then(challengeData => {
                        // console.log(practiceData);
                        // console.log(practiceData[this.selectedMode.type]);
                        // this.$store.commit('setPracticeSession', practiceData[this.selectedMode.type].practiceSession);
                        // this.$store.commit('setQuestionSet', practiceData[this.selectedMode.type].questionSet);

                        this.$store.commit('setChallengeSession', challengeData.challengeSession);
                        this.$store.commit('setPracticeSession', challengeData.practiceSession);
                        this.$store.commit('setQuestionSet', challengeData.questionSet);


                        this.$router.push(`/practice/${this.$store.state.challengeSession.type}`);
                    })
                    .catch(err => {
                        if(err instanceof Error){
                            console.error(`VIEW_CHALLENGE_SELECT_MODE/INIT_PRACTICE::FETCH_ERROR`);
                            this.$foneturkError({
                                text: this.$t(`error.fetch`),
                            });
                        }
                        else if(err.code === 'CHALLENGE_INITIALIZE_MODEL/INITIALIZE::INV_USER_SESSION'){
                            console.error(`VIEW_CHALLENGE_SELECT_MODE/INIT_PRACTICE::API_ERROR_01 --> ${err.code}`);
                            this.$foneturkError({
                                text: this.$t(`error.api.challengeInitialize.${err.code}`),
                                didClose: () => {
                                    console.warn("Routing to /login ...");
                                    // this.$router.push('/login');
                                }
                            });
                        }
                        else if(this.$te(`error.api.challengeInitialize.${err.code}`)){
                            console.error(`VIEW_CHALLENGE_SELECT_MODE/INIT_PRACTICE::API_ERROR_02 --> ${err.code}`);
                            this.$foneturkError({
                                text: this.$t(`error.api.challengeInitialize.${err.code}`),
                            });
                        }
                        else{
                            console.error(`VIEW_CHALLENGE_SELECT_MODE/INIT_PRACTICE::UNEXPECTED_API_ERROR --> ${err.code}`);
                            this.$foneturkError({
                                text: this.$t(`error.fetch`),
                            });
                        }
                        this.showPreloader = false;
                        this.canInit = true;
                    });
                
            }
        }
    }
</script>

<style scoped src="@/css/views/view-challenge-select-mode.css"></style>